import { render, staticRenderFns } from "./NeighborhoodEdit.vue?vue&type=template&id=182cf90a&scoped=true&"
import script from "./NeighborhoodEdit.vue?vue&type=script&lang=js&"
export * from "./NeighborhoodEdit.vue?vue&type=script&lang=js&"
import style0 from "./NeighborhoodEdit.vue?vue&type=style&index=0&id=182cf90a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182cf90a",
  null
  
)

export default component.exports